/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";

import { ClosePlayerButton } from "../../Interface";

import { NextEpisode } from "./Component";

import "./Container.scss";

interface NextEpisodeOverlayProps {
  timer: number;
  handleDismiss: () => void;
}

export const NextEpisodeOverlay = (props: NextEpisodeOverlayProps) => {
  const { timer, handleDismiss } = props;

  return (
    <div className="OverlayContainer" onClick={handleDismiss}>
      <div className="OverlayContainer__TopSection">
        <ClosePlayerButton />
      </div>
      <div className="OverlayContainer__CenterSection" />
      <div className="OverlayContainer__BottomSection">
        <NextEpisode timer={timer} />
      </div>
    </div>
  );
};
